module.exports = __webpack_public_path__ + "img/services-1.111a5d8e.png";